import React from "react";

import { Route, Redirect } from "react-router-dom";

export const AuthenticatedRouter = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("token") ||
      localStorage.getItem("unauthorizedUndp") ? (
        <div className="content-container">
          <Component {...props} />
        </div>
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);
